module.exports = __webpack_public_path__ + "img/Question Icon - white.605c140c.svg";